<template>
  <div>
    <CCard v-if="show">
      <CCardHeader>
        <CIcon name="cil-pencil"/>
        <strong> Logistica </strong>
        <div class="card-header-actions">
          <CLink
            class="card-header-action btn-minimize"
            @click="collapsed = !collapsed">
            <CIcon :name="`cil-chevron-${collapsed ? 'top' : 'bottom'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="collapsed">
        <CCardBody>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <CForm>
              <CRow>
                <CCol sm="6">
                  <validation-provider
                    name="gateway logistica"
                    rules="required|min:8|max:8"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      type="text"
                      v-model="form.gateway"
                      label="Gateway Logistica"
                      disabled
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="6">
                  <CInput
                    prepend="R$"
                    label="Frete Grátis"
                    placeholder="200,00"
                    v-model="form.frete_gratis"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="6">
                   <validation-provider
                      name="login SigepWeb"
                      rules="required|min:8|max:8"
                      v-slot="{ errors, valid, touched }"
                    >
                    <CInput
                      type="number"
                      valid-feedback
                      placeholder="Login SigepWeb"
                      :invalid-feedback="errors[0]"
                      label="Login SigepWeb Correios"
                      v-model="form.sigepweb_login"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="6">
                  <validation-provider
                    name="senha SigepWeb"
                    rules="required"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      valid-feedback
                      placeholder="Senha SigepWeb"
                      :invalid-feedback="errors[0]"
                      label="Senha SigepWeb Correios"
                      v-model="form.sigepweb_senha"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="6">
                  <validation-provider
                    name="código administrativo"
                    rules="required|min:8|max:8"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      type="number"
                      valid-feedback
                      placeholder="12345678"
                      :invalid-feedback="errors[0]"
                      v-model="form.cod_adm_correio"
                      label="Código Administrativo Correios"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <!-- Integrador -->
              <CRow v-if="form.integrador">
                <CCol sm="12">
                   <validation-provider
                      name="integrador"
                      rules="required|min:8|max:8"
                      v-slot="{ errors, valid, touched }"
                    >
                    <CInput
                      type="text"
                      placeholder=""
                      label="Integrador"
                      v-model="form.integrador"
                      disabled
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <!-- Login e senha integrador -->
              <CRow v-if="form.integrador">
                <CCol sm="6">
                    <validation-provider
                      name="login integrador"
                      rules="required|min:8|max:8"
                      v-slot="{ errors, valid, touched }"
                    >
                    <CInput
                      type="text"
                      valid-feedback
                      placeholder=""
                      :invalid-feedback="errors[0]"
                      :label="'Login ' + form.integrador_login"
                      v-model="form.integrador_login"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="6">
                  <validation-provider
                    name="senha integrador"
                    rules="required"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      valid-feedback
                      placeholder=""
                      :invalid-feedback="errors[0]"
                      :label="'Senha ' + form.integrador_senha"
                      v-model="form.integrador_senha"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <!-- Outros gateways -->
              <CRow v-if="showGateway">
                <CCol sm="6">
                  <validation-provider
                    name="login gateway"
                    rules="required|min:8|max:8"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      type="text"
                      valid-feedback
                      placeholder=""
                      :invalid-feedback="errors[0]"
                      :label="'Login ' + form.gateway"
                      v-model="form.gateway_login"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="6">
                  <validation-provider
                    name="senha SigepWeb"
                    rules="required"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      valid-feedback
                      placeholder=""
                      :invalid-feedback="errors[0]"
                      :label="'Senha ' + form.gateway"
                      v-model="form.gateway_senha"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow class="border-top">
                <CCol class="text-right">
                  <div class="mt-2">
                    <CButton
                      v-if="form.id"
                      class="mr-2"  
                      type="submit" 
                      color="success"
                      :disabled="invalid"
                      @click.prevent="update()">
                      Atualizar
                    </CButton>
                    <CButton
                      v-else
                      type="submit" 
                      color="primary"
                      :disabled="invalid"
                      @click.prevent="save()">
                      Enviar
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </validation-observer>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'logisticsForm',
    props: {
      show: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        showGateway: true,
        correioContrato: 'Cálculo de Frete (Correios, Jadlog e Total Express)',
        correioSemContrato: 'Cálculo de Frete (Somente Correios)'
      }
    },
    computed: {
      form: {
        get() {
          return this.$store.state.logistica
        }
      },
      collapsed: {
        get() { 
          return this.$store.state.forms.collapsed.logistica 
        },
        set() {
          this.$store.commit('setCollapsedTrue', 'logistica')
        }
      }
    },
    created() {
      this.showInput(this.form.gateway)
    },
    methods: {
      ...mapActions(['saveLogistica', 'updateLogistics']),
      save() {
        this.saveLogistica(this.form);
      },
      update() {
        this.updateLogistics(this.form)
      },
      showInput(data) {
        if (data === this.correioContrato || data === this.correioSemContrato) {
          this.showGateway = false;
        } 
      }
    }
  }
</script>
